import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/authSlice";
import signUpReducer from "../features/signUpSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    authSignUp: signUpReducer,
  },
});
